module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientForm"
  }, [_c('div', {
    staticClass: "border-bottom-medium mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.name),
      expression: "customer.name"
    }],
    staticClass: "fs-bigger bg-lighter bold",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-1"
  }, [_c('label', [_vm._v("Country:")]), _vm._v(" "), _c('v-select', {
    staticClass: "unChanged countryPicker fs-bigger",
    attrs: {
      "autocomplete": "no",
      "disabled": _vm.disabled,
      "options": _vm.getCountries,
      "label": "name",
      "placeholder": "- Select country -"
    },
    on: {
      "input": _vm.updateCountry
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-1"
  }, [_c('label', [_vm._v("Phone:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.phone),
      expression: "customer.phone"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-1"
  }, [_c('label', [_vm._v("Hotel:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.accomodation),
      expression: "customer.accomodation"
    }],
    staticClass: "fs-bigger bg-lighter",
    staticStyle: {
      "width": "40% !important"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.accomodation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "accomodation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-center"
  }, [_vm._v("Room:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.room),
      expression: "customer.room"
    }],
    staticClass: "ml-1 fs-bigger bg-lighter",
    staticStyle: {
      "width": "70px !important"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.room)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "room", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-1"
  }, [_c('label', [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.email),
      expression: "customer.email"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-1"
  }, [_c('label', [_vm._v("Notes:")]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [(_vm.reservation.note && _vm.reservation.note.length > 0) ? _c('div', {
    staticClass: "color-6 bold"
  }, [_vm._v(" 👇 Take a look at Notes")]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.note),
      expression: "reservation.note"
    }],
    staticClass: "fs-bigger bg-lighter darker bold",
    attrs: {
      "disabled": _vm.disabled,
      "rows": "1"
    },
    domProps: {
      "value": (_vm.reservation.note)
    },
    on: {
      "keyup": _vm.notesInputChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-medium pb-2 mb-2"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('label', [_vm._v("Extras:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flexGrow1"
  }, [_c('div', {
    staticClass: "bold fs-smaller d-flex flex-column flexGrow1"
  }, _vm._l((_vm.bookingComponents), function(bookingComponent) {
    return (bookingComponent.quantity > 0) ? _c('span', {
      class: {
        'dark': !bookingComponent.id
      }
    }, [_vm._v(_vm._s(bookingComponent.quantity) + " x " + _vm._s(bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name))]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn secondary small",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleEditExtas
    }
  }, [_vm._v("EDIT")]), _vm._v(" "), _c('button', {
    staticClass: "btn secondary small ml-2",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleAddExtas
    }
  }, [_vm._v("+ ADD EXTRAS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-medium pb-2 mb-2"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('label', [_vm._v("Transport:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flexGrow1"
  }, [_c('div', {
    staticClass: "bold fs-smaller d-flex flex-column flexGrow1"
  }, _vm._l((_vm.transport.transfers), function(transfer) {
    return (transfer.schedule) ? _c('span', [_vm._v("\n                        " + _vm._s((transfer.transportDirection == '1') ? 'Pickup' : 'Dropoff') + ":\n                        " + _vm._s(transfer.schedule.timeShort) + "\n                        " + _vm._s((transfer.transportDirection == '2') ? _vm.reservation.event.location + ' -' : '') + "\n                        " + _vm._s(transfer.stop.name) + "\n                        " + _vm._s((transfer.transportDirection == '1') ? '- ' + _vm.reservation.event.location : '') + "\n                    ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [(_vm.reservation.event.eventRoutes.length > 0) ? _c('button', {
    staticClass: "btn secondary small",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleEditTransport
    }
  }, [_vm._v("EDIT")]) : _c('span', {
    staticClass: "fs-small px-2 bold dark cursor-default"
  }, [_vm._v("No transport available")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-medium pb-2 mb-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('label', {
    staticClass: "d-flex flexGrow1"
  }, [_vm._v("Voucher code:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.bookingOperatorCode),
      expression: "reservation.bookingOperatorCode"
    }],
    staticClass: "w-100 px-2 py-1 text-center bg-lighter",
    staticStyle: {
      "width": "200px !important"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.bookingOperatorCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "bookingOperatorCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.reservation.customer.bookingQuestion) ? _c('div', {
    staticClass: "border-bottom-medium pb-2 mb-2"
  }, [_c('div', {
    staticClass: "d-flexjustify-content-between align-items-center"
  }, [_c('label', {
    staticClass: "d-flex w-100 flexGrow1"
  }, [_vm._v(_vm._s(_vm.reservation.customer.bookingQuestion))])]), _vm._v(" "), _c('div', {
    staticClass: "dark"
  }, [(_vm.reservation.customer.bookingAnswer) ? _c('div', [_vm._v(_vm._s(_vm.reservation.customer.bookingAnswer))]) : _c('div', [_vm._v("No answer")])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5083aeff", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5083aeff"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabDetails/ClientForm.vue
// module id = 1751
// module chunks = 0